// extracted by mini-css-extract-plugin
module.exports = {"theTeam":"Team-module--theTeam--3bff-","scrollAnchor":"Team-module--scrollAnchor--2523w"};